import React, { useState, useEffect } from 'react';
import TagSearch from '../TagChoicePage/sections/TagSearch';
import TagCloud from '../TagChoicePage/sections/TagCloud';
import { useNavigate } from 'react-router-dom';
import ReturnButton from '../../components/ui/ReturnButton'; 
import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';

const TagChoicePage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState(''); // Состояние для поискового запроса
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleTagClick = (apiUrl, id) => {
    navigate(`/tags/${id}`);
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const apiUrl = process.env.REACT_APP_API_URL;

        const tagsResponse = await fetch(`${apiUrl}/tags`);
        const tagsData = tagsResponse.ok ? await tagsResponse.json() : [];

        // Нормализуем данные (убираем возможную обёртку)
        const normalizedTags = tagsData.data || (Array.isArray(tagsData) ? tagsData : []);
        
        console.log('Загруженные теги:', normalizedTags);
        setTags(normalizedTags);

      } catch (err) {
        console.error('Ошибка:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      } 
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div id="tagSearchPageContainer" className="flex-column">
        <Header />
        <ReturnButton />
        <div className="loading-spinner">Загрузка тегов...</div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div id="tagSearchPageContainer" className="flex-column">
        <Header />
        <ReturnButton />
        <div className="error-message">Ошибка: {error}</div>
        <Footer />
      </div>
    );
  }

  return (
    <div id="tagSearchPageContainer" className="flex-column">
      <Header />
      <ReturnButton />
      <TagSearch searchQuery={searchQuery} onSearchChange={handleSearchChange} />
      <TagCloud tags={tags} onTagClick={handleTagClick} searchQuery={searchQuery} />
      <Footer />
    </div>
  );
};

export default TagChoicePage;